export class RequestAccessCardCancellation {
  id: number;
  requestId: number;
  companyId: number;
  companyName: string;
  requestNumber: string;
  requestDate: Date;
  requestTypeId: number;
  requestTypeName: string;
  requestStatusId: number;
  requestStatusName: string;
  requestorId: number;
  requestorName: string;
  onBehalfId: number;
  onBehalfName: string;
  badgeNumber: string;
  requestAccessCardCancellationReasonId: number;
  requestAccessCardCancellationReasonName: string;
  accessCardTypeId: number;
  accessCardTypeName: string;
  endDate: Date;
}



// WEBPACK FOOTER //
// ./src/app/core/models/request-access-card-cancellation.ts